import { gql } from '@apollo/client';

export const USER_FRAGMENT = gql`
  fragment userFragment on User {
    id
    phone
    lastName
    firstName
    email
    status
    createdAt
    roleList {
      role
      entityId
      entityType
      entityName {
        ... on AdAccountRole {
          accountName
        }
        ... on GenericRole {
          id
        }
      }
    }
  }
`;
